// extracted by mini-css-extract-plugin
module.exports = {"textField":"ResetPassword_textField__3YCJS","error":"ResetPassword_error__30qSO"};